import React from 'react';
import Link from 'next/link';
import Image from 'next/image';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faTimes} from '@fortawesome/free-solid-svg-icons/faTimes';
import styles from '../../components/styles/elements/FullPopup.module.scss';

const withFullPopup = (Component) => (
    function withFullPopup (props) {
        const {title, ...passedProps} = props;
        const {closePopup} = passedProps;
    
        return (
            <div className={styles.root}>
                <div className="d-flex justify-content-between align-items-center">
                    <Link href="/" className={styles.logo} >

                        <Image src="/images/icons/conso.png" width={111} height={33} alt="Conso" />

                    </Link>
                    <div className={styles.close} onClick={closePopup} >
                        <FontAwesomeIcon className="me-2" icon={faTimes} height="16" width="16" />
                        Închide
                    </div>
                </div>
                <div className={`${styles.header} `}>
                   {title} 
                </div>
                <Component {...passedProps} closePopup={closePopup} />
            </div>
        );
    } 
);

export default withFullPopup;